import { createAction, props } from '@ngrx/store';
import { IResponseBadRequest } from '@core/interfaces';
import { ConfiguracionCanal } from '@core/models'

export const CHANNEL_SETTING_FIND_ALL = createAction('[ConfiguracionCanal] Find All');
export const CHANNEL_SETTING_FIND_SUCCESS = createAction('[ConfiguracionCanal] Find Success', props<{ ConfiguracionCanal: ConfiguracionCanal|null }>());
export const CHANNEL_SETTING_FIND_ALL_SUCCESS = createAction('[ConfiguracionCanal] Find All Success', props<{ ConfiguracionCanalList: ConfiguracionCanal[] }>());

export const CHANNEL_SETTING_FAILURE = createAction('[ConfiguracionCanal] Failure', props<{ error: IResponseBadRequest }>());

export const CHANNEL_SETTING_RESET = createAction('[ConfiguracionCanal] Reset');
export const CHANNEL_SETTING_CLEAR_STATE = createAction('[ConfiguracionCanal] Clear State');

export const CHANNEL_SETTING_UPDATE_LOADING = createAction('[ConfiguracionCanal] Update Loading', props<{ loading: boolean }>());
